/**
 * Constants related to AI site builder
 */

export const TARGET_AI_SITE_GEN_LIBRARY_SLUG =
  'ai-gen-82921b10-4b39-48f0-b346-808cf4903d29';
